import React from "react";

const CheckMark = ({style = {}, size = "36", className = "", fill = "#73788B", stroke="#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill-stroke"
            d="M31.118 5.79L14 23.246l-9.12-9.299-.214-.218-.214.218-2.666 2.719-.206.21.206.21 12 12.235.214.219.214-.219 20-20.392.206-.21-.206-.21-2.668-2.72-.214-.217-.214.218z"
            fill={fill}
            stroke={stroke}
            strokeWidth={0.6}
      />
    </svg>
);

export default CheckMark;
